import React, { useEffect, useRef, useState } from 'react'
import {
  ScrollView,
  StyleSheet,
  Text as RNText,
  TouchableOpacity,
  View
} from 'react-native'
import { Box, Flex, Text, useColorMode } from 'native-base'
import { RFPercentage } from 'react-native-responsive-fontsize'
import { AntDesign, Feather } from '@expo/vector-icons'
import { useNavigation, useRoute } from '@react-navigation/native'
import Api from '../../../../Api/Api'
import Template from '../../../template/Index.tsx'
import TemplateEtapas from '../../../template/Etapas/Index'
import { CORES, sombraCard } from '../../../template/Etapas/styles'
import { corTextoSobre } from '../../../theme/cores'
import createStyles from './styles'
import SkeletonHorario from '../../../components/Skeleton/Horario'
import { useTheme } from '../../../../ThemeProvider.tsx'

const DOURADO = '#C9A24E'

export default function Horarios({}) {
  const navigation = useNavigation()
  const route = useRoute()

  const [data_selecionada, setDataSelecionada] = useState<Date>()
  const [horarios, setHorarios] = useState<any>([])
  const [buscando, setBuscando] = useState<Boolean>(false)
  const [horarioSelecionado, setHorarioSelecionado] = useState<any>(null)
  const refFaixaDias = useRef<any>(null)

  const { getCodEmpresa, getIntervaloAgendamento, configEmpresa, primaryColor } =
    useTheme()

  const { colorMode } = useColorMode()
  const [getConfigEmpresa, setConfigEmpresa] = useState<any>(
    JSON.parse(configEmpresa)
  )

  const styles = createStyles(getConfigEmpresa.coresPWA)

  const refModal = useRef()

  const meses = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro'
  ]

  const abrev_dias_semana = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab']

  useEffect(() => {
    setDataSelecionada(route.params.data_selecionada)
  }, [])

  useEffect(() => {
    setBuscando(true)
  }, [data_selecionada])

  useEffect(() => {
    if (buscando && data_selecionada != undefined && data_selecionada != null) {
      getHorariosAtendimento()
    }
  }, [buscando])

  async function getHorariosAtendimento() {
    if (data_selecionada) {
      const id_empresa = getCodEmpresa

      let horarios = await Api.horarios_atendimento(
        data_selecionada,
        id_empresa,
        route.params.profissional_selecionado.id,
        getIntervaloAgendamento
      )

      if (!horarios.status) {
        refModal.current.abrirModal('Erro ao buscar os horários de atendimento')
        return
      }
      console.log(
        'config se é por intervalo de tempo',
        getConfigEmpresa.intervaloComTempoServico
      )
      console.log(
        'profissional selecionado........ ',
        route.params.profissional_selecionado.intervaloComTempoServico
      )

      if (route.params.profissional_selecionado.intervaloComTempoServico) {
        //esse bloco é responsável por bloquear os horários anteriores ao agendamento existemte.
        // pega o tempo total gasto com os serviços selecionados, pega o horário bloqueado e subtrai o tempo total gasto, bloqueia o que não da tempo.

        const tempoTotalGasto = route.params.servicos_selecionados.reduce(
          (total, current) => {
            return total + current.tempo
          },
          0
        )

        const retornaOsBloqueados = horarios.data.filter(
          (item: any) => item.disponivel == false
        )
        for (const hr of retornaOsBloqueados) {
          const [horas, minutos] = hr.horario.split(':').map(Number)
          const data = new Date()
          data.setHours(horas)
          data.setMinutes(minutos)
          data.setMinutes(data.getMinutes() - (tempoTotalGasto - 1))

          const novoHorarioString = `${String(data.getHours()).padStart(
            2,
            '0'
          )}:${String(data.getMinutes()).padStart(2, '0')}`

          for (const item of horarios.data) {
            if (
              item.horario >= novoHorarioString &&
              item.horario <= hr.horario
            ) {
              item.disponivel = false
            }
          }
        }

        // passa remover os horários que não estão disponíveis
        // horarios.data = horarios.data.filter((item: any) => item.disponivel == true);
      }

      if (getConfigEmpresa.ocultarHorariosIndisponiveis) {
        const servicosDisponiveis = horarios.data.filter(
          (item: any) => item.disponivel
        )
        horarios.data = servicosDisponiveis
      }

      const qtd = 3
      const result = horarios.data.reduce((total, current, index) => {
        const belongArrayIndex = Math.floor(index / qtd)
        if (!total[belongArrayIndex]) {
          total[belongArrayIndex] = []
        }
        total[belongArrayIndex].push(current)
        return total
      }, [])

      setHorarios(result)
      setBuscando(false)
    }
  }

  function renderCabecalhoData() {
    // valida se a data selecionada é igual a data atual
    if (!data_selecionada) {
      return
    }

    const valida_data_igual =
      new Date().getDate() == data_selecionada.getDate() &&
      new Date().getMonth() == data_selecionada.getMonth() &&
      new Date().getFullYear() == data_selecionada.getFullYear()

    return (
      <Flex style={styles.navigationContainer}>
        <TouchableOpacity
          // <Button
          style={[
            styles.navButton,
            {
              backgroundColor:
                valida_data_igual || buscando
                  ? 'rgba(189, 197, 218, 0.6)'
                  : getConfigEmpresa.coresPWA.corFundoBotoesAvancarHorario
            }
          ]}
          disabled={valida_data_igual || Boolean(buscando)}
          onPress={() => {
            const data = new Date(data_selecionada)
            data.setDate(data.getDate() - 1)
            setDataSelecionada(data)
          }}
          // variant='unstyled' _pressed={{ bg: 'rgba(189, 197, 218, 0.6)' }}
        >
          <AntDesign
            name='arrowleft'
            size={RFPercentage(2.5)}
            style={[
              styles.navButtonText,
              {
                color:
                  valida_data_igual || buscando
                    ? 'rgba(189, 197, 218, 0.6)'
                    : 'black'
              }
            ]}
          />
        </TouchableOpacity>

        <Text style={styles.dateText}>
          <Text style={styles.dateTextDia}>
            {valida_data_igual
              ? 'Hoje'
              : abrev_dias_semana[data_selecionada.getDay()]}
          </Text>{' '}
          -{' '}
          {data_selecionada
            ? data_selecionada.getDate() +
              ' ' +
              meses[data_selecionada.getMonth()] +
              ' ' +
              data_selecionada.getFullYear()
            : ''}
        </Text>

        <TouchableOpacity
          style={[
            styles.navButton,
            {
              backgroundColor: buscando
                ? 'rgba(189, 197, 218, 0.6)'
                : getConfigEmpresa.coresPWA.corFundoBotoesAvancarHorario
            }
          ]}
          disabled={Boolean(buscando)}
          // variant='unstyled' _pressed={{ bg: 'rgba(189, 197, 218, 0.6)' }}
          onPress={() => {
            const data = new Date(data_selecionada)
            data.setDate(data.getDate() + 1)
            setDataSelecionada(data)
          }}
        >
          <AntDesign
            name='arrowright'
            size={RFPercentage(2.5)}
            style={[
              styles.navButtonText,
              { color: buscando ? 'rgba(189, 197, 218, 0.6)' : 'black' }
            ]}
          />
        </TouchableOpacity>
      </Flex>
    )
  }

  function renderHorarios(item: any, index: number) {
    return (
      <Flex key={index} style={styles.container}>
        {item.map((item: any, index: number) => {
          return (
            <TouchableOpacity
              // <Pressable
              key={index}
              style={[
                styles.pressable,
                {
                  backgroundColor: item.disponivel
                    ? getConfigEmpresa.coresPWA.corDisponivelCalendario
                    : getConfigEmpresa.coresPWA
                        .corIndisponivelDisponivelCalendario
                    ? getConfigEmpresa.coresPWA
                        .corIndisponivelDisponivelCalendario
                    : 'trueGray.100'
                }
              ]}
              onPress={() => {
                if (item.disponivel) {
                  navigation.navigate('DadosUsuario', {
                    ...route.params,
                    horarios_selecionado: item,
                    data_selecionada: data_selecionada
                  })
                } else {
                  refModal.current.abrirModal('Horário não disponível')
                }
              }}
            >
              <Text
                style={{
                  color: item.disponivel
                    ? getConfigEmpresa.coresPWA.corFonteItemHorarios
                    : 'rgba(189, 197, 218, 0.9)',
                  fontSize: RFPercentage(2.5)
                }}
              >
                {item.horario}
              </Text>
            </TouchableOpacity>
          )
        })}
      </Flex>
    )
  }

  // ---------------- Layout novo ----------------
  // O modo legado (pwa simples / layout v2 / tema escuro) continua com o template antigo
  const utilizaLayoutLegado =
    getConfigEmpresa.utilizaPwaSimples ||
    getConfigEmpresa.versaoPWA == 2 ||
    getConfigEmpresa.utilizaTemaEscuro

  const corPrincipal: string = primaryColor || '#006400'
  const corTextoPrincipal = corTextoSobre(corPrincipal)
  const diasAtendimento: number[] | undefined = route.params?.dias_atendimento

  function mesmoDia(a: Date | undefined, b: Date) {
    return (
      !!a &&
      a.getDate() === b.getDate() &&
      a.getMonth() === b.getMonth() &&
      a.getFullYear() === b.getFullYear()
    )
  }

  function irParaDados(horario: any) {
    navigation.navigate('DadosUsuario', {
      ...route.params,
      horarios_selecionado: horario,
      data_selecionada: data_selecionada
    })
  }

  function alterarDia(data: Date) {
    setHorarioSelecionado(null)
    setDataSelecionada(data)
  }

  // Dias exibidos na faixa: de hoje até pelo menos uma semana depois do dia escolhido
  function montarDiasFaixa() {
    const hoje = new Date()
    const inicio = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate())
    const dias: Date[] = []
    let quantidade = 21

    if (data_selecionada) {
      const diff = Math.round(
        (new Date(
          data_selecionada.getFullYear(),
          data_selecionada.getMonth(),
          data_selecionada.getDate()
        ).getTime() -
          inicio.getTime()) /
          86400000
      )
      quantidade = Math.max(quantidade, diff + 8)
    }

    for (let i = 0; i < quantidade; i++) {
      dias.push(
        new Date(inicio.getFullYear(), inicio.getMonth(), inicio.getDate() + i)
      )
    }
    return dias
  }

  const LARGURA_DIA = 58
  const ESPACO_DIA = 8

  function renderFaixaDias() {
    const dias = montarDiasFaixa()
    const indiceSelecionado = dias.findIndex((d) => mesmoDia(data_selecionada, d))

    return (
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        ref={refFaixaDias}
        onLayout={() => {
          if (indiceSelecionado > 0) {
            refFaixaDias.current?.scrollTo({
              x: Math.max(0, indiceSelecionado * (LARGURA_DIA + ESPACO_DIA) - 16),
              animated: false
            })
          }
        }}
        contentContainerStyle={{ gap: ESPACO_DIA, paddingVertical: 4 }}
      >
        {dias.map((dia) => {
          const selecionado = mesmoDia(data_selecionada, dia)
          const fechado = !!diasAtendimento && !diasAtendimento.includes(dia.getDay())

          return (
            <TouchableOpacity
              key={dia.toISOString()}
              disabled={fechado || Boolean(buscando)}
              onPress={() => alterarDia(dia)}
              style={[
                stylesNovo.dia,
                sombraCard,
                selecionado && {
                  backgroundColor: corPrincipal,
                  borderColor: corPrincipal
                },
                fechado && { opacity: 0.4 }
              ]}
            >
              <RNText
                style={[
                  stylesNovo.semanaDia,
                  selecionado && { color: corTextoPrincipal, opacity: 0.85 }
                ]}
              >
                {abrev_dias_semana[dia.getDay()].toUpperCase()}
              </RNText>
              <RNText
                style={[
                  stylesNovo.numeroDia,
                  selecionado && { color: corTextoPrincipal }
                ]}
              >
                {dia.getDate()}
              </RNText>
            </TouchableOpacity>
          )
        })}
      </ScrollView>
    )
  }

  const PERIODOS = [
    { titulo: 'Manhã', icone: 'sunrise', de: '00:00', ate: '11:59' },
    { titulo: 'Tarde', icone: 'sun', de: '12:00', ate: '17:59' },
    { titulo: 'Noite', icone: 'moon', de: '18:00', ate: '23:59' }
  ]

  function renderPeriodos() {
    const todos: any[] = horarios.flat()

    if (todos.length === 0) {
      return (
        <View style={stylesNovo.vazio}>
          <Feather name='clock' size={40} color={CORES.subtitulo} />
          <RNText style={stylesNovo.textoVazio}>
            Sem horários disponíveis para este dia.
          </RNText>
        </View>
      )
    }

    return PERIODOS.map((periodo) => {
      const doPeriodo = todos.filter(
        (h) => h.horario >= periodo.de && h.horario <= periodo.ate
      )

      if (doPeriodo.length === 0) {
        return null
      }

      const disponiveis = doPeriodo.filter((h) => h.disponivel).length

      return (
        <View key={periodo.titulo} style={stylesNovo.periodo}>
          <View style={stylesNovo.cabecalhoPeriodo}>
            <Feather name={periodo.icone as any} size={15} color={DOURADO} />
            <RNText style={stylesNovo.tituloPeriodo}>{periodo.titulo}</RNText>
            <RNText style={stylesNovo.qtdPeriodo}>
              {disponiveis} {disponiveis === 1 ? 'horário' : 'horários'}
            </RNText>
          </View>

          <View style={stylesNovo.grade}>
            {doPeriodo.map((item: any) => {
              const selecionado = horarioSelecionado?.horario === item.horario

              return (
                <TouchableOpacity
                  key={item.horario}
                  disabled={!item.disponivel}
                  onPress={() => {
                    // o toque já avança; o botão do rodapé fica para quando o cliente voltar
                    setHorarioSelecionado(item)
                    irParaDados(item)
                  }}
                  style={[
                    stylesNovo.horario,
                    item.disponivel && sombraCard,
                    !item.disponivel && stylesNovo.horarioIndisponivel,
                    selecionado && {
                      backgroundColor: corPrincipal,
                      borderColor: corPrincipal
                    }
                  ]}
                >
                  <RNText
                    style={[
                      stylesNovo.textoHorario,
                      !item.disponivel && stylesNovo.textoHorarioIndisponivel,
                      selecionado && { color: corTextoPrincipal, fontWeight: '800' }
                    ]}
                  >
                    {item.horario}
                  </RNText>
                </TouchableOpacity>
              )
            })}
          </View>
        </View>
      )
    })
  }

  if (!utilizaLayoutLegado) {
    const resumoData = data_selecionada
      ? abrev_dias_semana[data_selecionada.getDay()] +
        ', ' +
        data_selecionada.getDate() +
        ' de ' +
        meses[data_selecionada.getMonth()].substring(0, 3).toLowerCase()
      : ''

    return (
      <TemplateEtapas
        ref={refModal}
        etapaAtual={4}
        totalEtapas={5}
        titulo={'Escolha o\nmelhor horário'}
        subtitulo={
          data_selecionada
            ? meses[data_selecionada.getMonth()] +
              ' ' +
              data_selecionada.getFullYear()
            : ''
        }
        filtro={renderFaixaDias()}
        resumoRotulo={resumoData}
        resumoValor={
          horarioSelecionado ? 'às ' + horarioSelecionado.horario : 'Escolha um horário'
        }
        desabilitarBotao={!horarioSelecionado}
        onBotaoClick={() => {
          if (!horarioSelecionado) {
            refModal.current.abrirModal('Selecione um horário')
            return
          }

          irParaDados(horarioSelecionado)
        }}
      >
        {buscando ? <SkeletonHorario /> : renderPeriodos()}
      </TemplateEtapas>
    )
  }

  // ---------------- Layout legado ----------------
  return (
    <Template
      titulo={'Selecione o Horário'}
      messageAlerta='Por gentileza, selecione o horário que deseja realizar o(s) serviço(s)'
      // disabled_button_proximo={mensagemRodape != ''}
      onBotaoProximoClick={() => {
        refModal.current.abrirModal('Selecione um horário')
      }}
      ref={refModal}
      filtro={renderCabecalhoData()}
    >
      {buscando ? (
        <SkeletonHorario />
      ) : (
        <Box style={styles.mainContainer}>
          {horarios.map((item: any, index: number) => {
            return renderHorarios(item, index)
          })}
        </Box>
      )}

      {horarios.length == 0 &&
        !buscando &&
        data_selecionada != null &&
        data_selecionada != undefined && (
          <Box style={styles.boxTexto}>
            <AntDesign name='closecircle' size={RFPercentage(4)} color='red' />
            <Text
              style={[
                styles.textoDisp,
                {
                  color: getConfigEmpresa.coresPWA.corFontePrimaria
                }
              ]}
            >
              {'Desculpe, sem horários disponíveis para o dia selecionado'}
            </Text>
          </Box>
        )}
    </Template>
  )
}

const stylesNovo = StyleSheet.create({
  dia: {
    width: 58,
    paddingVertical: 10,
    borderRadius: 14,
    backgroundColor: CORES.card,
    borderWidth: 1,
    borderColor: CORES.borda,
    alignItems: 'center',
    gap: 2
  },
  semanaDia: {
    fontSize: 10,
    fontWeight: '700',
    color: CORES.subtitulo,
    letterSpacing: 0.5
  },
  numeroDia: {
    fontSize: 18,
    fontWeight: '800',
    color: CORES.titulo
  },
  periodo: {
    marginBottom: 18
  },
  cabecalhoPeriodo: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    marginBottom: 10
  },
  tituloPeriodo: {
    fontSize: 15,
    fontWeight: '700',
    color: CORES.titulo
  },
  qtdPeriodo: {
    fontSize: 12,
    color: CORES.subtitulo
  },
  grade: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8
  },
  horario: {
    width: '31.5%',
    height: 46,
    borderRadius: 12,
    backgroundColor: CORES.card,
    borderWidth: 1,
    borderColor: CORES.borda,
    alignItems: 'center',
    justifyContent: 'center'
  },
  horarioIndisponivel: {
    backgroundColor: 'transparent',
    borderColor: 'rgba(0,0,0,0.05)'
  },
  textoHorario: {
    fontSize: 15,
    fontWeight: '600',
    color: CORES.titulo
  },
  textoHorarioIndisponivel: {
    color: '#c7c2b8',
    textDecorationLine: 'line-through'
  },
  vazio: {
    alignItems: 'center',
    paddingVertical: 40,
    gap: 12
  },
  textoVazio: {
    fontSize: 15,
    color: CORES.subtitulo,
    textAlign: 'center'
  }
})
